/**
 * HelpIcon/index.js
 * desc: user help icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const HelpIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="help icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.help.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM9 17v-2h2v2H9zm3.17-6.83l.9-.92c.57-.57.93-1.37.93-2.25 0-2.21-1.79-4-4-4S6 4.79 6 7h2c0-1.1.9-2 2-2s2 .9 2 2c0 .55-.22 1.05-.59 1.41l-1.24 1.26C9.45 10.4 9 11.4 9 12.5v.5h2c0-1.5.45-2.1 1.17-2.83z"/></svg>
    </IconButton>
);


export default HelpIcon;
